import './main.scss';

import svg4everybody from 'svg4everybody';
import events from './components/events/events';
import './components/sidebar/sidebar';
import './components/dropdown/dropdown';
import './components/header/header';
import './components/breakpoint/breakpoint';

var gettext = gettext || function(s) {return s};
global.gettext = gettext;

document.addEventListener('DOMContentLoaded', function(){
	svg4everybody();

	const sidebar = document.getElementById('sidebar');
	if (sidebar && sidebar.innerHTML.trim() !== '') {
		document.body.classList.remove('collapse-leftbar');
	}

	events.emit('main.inited');
});